import { MetaMaskProvider } from '@metamask/sdk-react';
import { getMetaMaskProvider } from '../../utils/helper';
import React from 'react';
function MetamaskLayout({ children }) {
  return getMetaMaskProvider() ? (
    <MetaMaskProvider
      sdkOptions={{
        logging: {
          developerMode: false,
        },
        shouldShimWeb3: true,

        i18nOptions: {
          enabled: true,
        },
      }}
    >
      {children}
    </MetaMaskProvider>
  ) : (
    <>{children}</>
  );
}

export default MetamaskLayout;
